<span class="totalResult">
    <strong class="totalResult-nb"><ng-content select="[number]"></ng-content></strong>
    <ng-content select="[label]"></ng-content>
</span>
